import { request } from './request';
import Api from '../apis/api';

export function getUserProjects(parse) {
  return request({
    method: 'post',
    url: Api.getUserProjects,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
export function getApiCollections(parse) {
  return request({
    method: 'get',
    url: Api.getApiCollections,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
// 添加接口
export function addProject(parse) {
  return request({
    method: 'post',
    url: Api.addProject,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
// 删除接口
export function deleteProject(parse) {
  return request({
    method: 'post',
    url: Api.deleteProject,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
// 新增用户信息
export function registerUser(parse) {
  console.log(parse, '新增用户信息');
  return request({
    method: 'post',
    url: Api.registerUser,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
// 发布接口
export function modifyProject_statues(parse) {
  return request({
    method: 'post',
    url: Api.modifyProject_statues,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: {
      ...parse,
    },
  });
}
// 保存项目
export function modifyProject(parse) {
  return request({
    method: 'post',
    url: Api.modifyProject,
    headers: {
      'content-type': 'application/json',
    },
    data: {
      ...parse,
    },
  });
}
// 添加模板
export function addTemplate(parse) {
  return request({
    method: 'post',
    url: Api.addTemplate,
    headers: {
      'content-type': 'application/json',
    },
    data: {
      ...parse,
    },
  });
}
// 删除模板
export function delTemplate(parse) {
  return request({
    method: 'post',
    url: Api.delTemplate,
    headers: {
      'content-type': 'application/json',
    },
    data: {
      ...parse,
    },
  });
}
